module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3r1n2r-4bcbff1c91944e5e3ff57eb19a39f3eb.svg";